import React, { useEffect, useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete
} from '@mui/material'
import axios from 'axios'
import apiUrl from '../../configs/constant';
import { useToast } from '../../components/ToastProvider'

interface Props {
    open: boolean
    mode: any,
    data: any
    onClose: () => void
}

const formatNumber = (value: string) => {
    const raw = value.replace(/[^0-9,]/g, '')
    const parts = raw.split(',')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return parts.join(',')
}

export default function DialogPenerimaan({
    open,
    mode,
    data,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const [selectedData, setSelectedData] = useState<any>(null)
    const [listAkun, setListAkun] = useState<any[]>([])
    const [akun, setAkun] = useState<any>(null)
    const [tglCair, setTglCair] = useState('')
    const [total, setTotal] = useState('')

    useEffect(() => {
        if (!open) return
        setTglCair(data.tgl?.split(' ')[0])
        setTotal(formatNumber(String(data.total ?? '')))

        getDetail(data.id)
    }, [open, data])

    const getAkun = (ids: any) => {

        let url = apiUrl.apiUrl + '/acc/dp/list-akun'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    data.forEach(element => {
                        if (element.id == ids) {
                            setAkun(element)
                        }
                    })

                    setListAkun(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    setSelectedData(data)

                    getAkun(data.accakun_id)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleSubmit = async () => {
        const payload = {
            akun_id: akun.id,
            tgl_cair: tglCair,
            total: total.replace(/\./g, '').replace(',', '.')
        }

        const url = apiUrl.apiUrl + '/acc/dp-customer/penerimaan/' + data.id

        axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success')

            onClose()
        })
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                {mode === 'edit' ? 'Lihat Penerimaan' : 'Buat Penerimaan'}
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                        <Autocomplete
                            options={listAkun}
                            value={akun}
                            onChange={(_, v) => setAkun(v)}
                            getOptionLabel={(o) => o.nama}
                            renderInput={(p) => (
                                <TextField {...p} label="Akun Penerimaan" />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            type="date"
                            label="Tanggal Cair"
                            value={tglCair}
                            onChange={(e) => setTglCair(e.target.value)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Total"
                            value={total}
                            onChange={(e) => setTotal(formatNumber(e.target.value))}
                            fullWidth
                            inputProps={{ inputMode: 'numeric' }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                {selectedData?.tgl_cair ? (
                    <Button fullWidth variant="contained" color='inherit' onClick={onClose}>
                        CLOSE
                    </Button>
                ) : (
                    <Button fullWidth variant="contained" onClick={handleSubmit}>
                        SIMPAN
                    </Button>
                )}

            </DialogActions>
        </Dialog>
    )
}

